<template>
  <teleport to="body">
    <component v-if="modalStore.isOpen" :is="modalShell" :title="modalStore.modalTitle" @close="modalStore.closeModal">
      <component :is="modalContent" v-bind="modalStore.modalProps" />
    </component>
  </teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ModalLarge from '@/components/shared/composite/ModalLarge.vue';
import ModalMiddle from '@/components/shared/composite/ModalMiddle.vue';
import ModalNewDesign from '@/components/shared/composite/ModalNewDesign.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useModalStore } from '@/stores/modal';
import { MODAL_REGISTRY } from '@/utils/constants/modal';

const modalStore = useModalStore();

const modalShell = computed(() => {
  switch (MODAL_REGISTRY[modalStore.modalKey]?.size || null) {
    case 'small':
      return ModalSmall;
    case 'medium':
      return ModalMiddle;
    case 'large':
      return ModalLarge;
    case 'new-design':
      return ModalNewDesign;
    case 'overlay':
      return 'div';
    default:
      return ModalMiddle;
  }
});

const modalContent = computed(() => {
  return MODAL_REGISTRY[modalStore.modalKey]?.component || null;
});
</script>

<style scoped></style>
